import React from "react";

/**
 * ProtectedAction blocca o mostra contenuto in base a:
 * - user.role → ruolo dell'utente
 * - contractState → stato del contratto
 * - optional condition → funzione custom che restituisce boolean
 */
const ProtectedAction = ({ user, contractState, roles = [], condition, children }) => {
  // Controllo ruoli
  console.log("roles",roles);
  console.log("user.role",user.role);
  const hasRole = roles.length === 0 || roles.includes(user.role);
  console.log("hasRole",hasRole);
  // Controllo condizione custom
  const customCondition = condition ? condition(user, contractState) : true;
  console.log("customCondition",customCondition);
  // Controllo stato contratto
  const isContractActive = !contractState || contractState === "ATTIVO"|| contractState === "IN_ATTESA_PAGAMENTO";

  if ((hasRole && isContractActive) && customCondition) {
    return <>{children}</>;
  }
  return null;
  };
  export default ProtectedAction;